import type { NativeGameCatalogItem } from '@/types/aggregation/category-v2';
import type { Game } from '@/types/games';

const getUidFromUrn = (urn: string): string => urn.split(':').at(-1) ?? urn;

export const adaptNativeGame = (catalogItem: NativeGameCatalogItem): Game =>
    ({
        id: catalogItem.id,
        uid: getUidFromUrn(catalogItem.urn),
        type: 'game',
        data: {
            ...catalogItem.data,
            background: catalogItem.data.background ?? catalogItem.data.flattened,
            rgs_code_desktop: catalogItem.data.rgs_code_desktop ?? catalogItem.data.rgs_code_mobile, // fallback, some consumers use only desktop no matter the platform
            feeds_code_desktop: catalogItem.data.feeds_code_desktop ?? catalogItem.data.feeds_code_mobile
        }
    }) as Game;
